import { useEffect } from "react";

import { useTour } from "hooks/useTour";

export function usePreferenciaCobrancaPage() {
  const { showTour, setTourType, setSteps, tourStep, tourType } = useTour();

  useEffect(() => {
    setTourType("preferencia-cobranca");
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  return { showTour, tourStep, tourType };
}
